<div class="text-end d-flex justify-content-between mb-3"
     *ngIf="outlets && outlets.length > 1">
  <ui-stores-map-btn
    (click)="storesMapRequested.emit()"
  ></ui-stores-map-btn>

  <ui-expand-input
    *ngIf="outlets.length > 10"
    [placeholder]="'common.search' | translate"
    [align]="'left'"
    [(model)]="search"
    (modelChange)="onFilterChange.emit($event)"></ui-expand-input>
</div>

<div class="fw-bold font-xl mb-2 d-none d-md-block"
     *ngIf="showTitle"
     [translate]="'orderProcess.delivery.chooseOutlet.whereDoYouWantToPickUp'">Where do you want to pick up?
</div>

<div class="custom-accordion custom-accordion-mobile bottom-space custom-accordion-scroll">
  <div ngbAccordion #accordion="ngbAccordion"
       [closeOthers]="true">
    @for (outlet of outlets | cFilterByFields : search : ['name', 'email', 'address', 'cityName']; track outlet) {
      @if (!outlet.unavailableProductTypes) {
        <div [ngbAccordionItem]="panelIdPrefix + outlet.id"
             (shown)="onOutletOpened(outlet.id)">
          <h2 ngbAccordionHeader>
            <button ngbAccordionButton>
              <div class="title outlet-title d-none d-md-grid">
                <div class="outlet-name">
                  {{ outlet.name }}
                </div>
                <div class="outlet-city">{{ outlet.cityName }}</div>
              </div>

              <div class="d-md-none">
                <div class="w-100 fw-bold outlet-name">{{ outlet.name }}</div>
                <div class="font-xs fw-normal">{{ outlet.address }}, {{ outlet.cityName }}</div>
              </div>

              <i class="icon-chevron-down"></i>
              <i class="icon-chevron-up"></i>
            </button>
          </h2>

          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              <ng-template>
                <pickup-outlet
                  [bakeryId]="bakeryId"
                  [outlet]="outlet"
                  [containerRef]="containerRef"
                  [scheduleType]="scheduleType"
                  [nextBtnTextKey]="nextBtnTextKey"
                  [nextBtnView]="nextBtnView"
                  [fullCapacityDays]="fullCapacityDays"
                  [availableProductTypes]="availabilityByOutletId.get(outlet.id)?.availableProductTypes"
                  [dailyStockSoldOutProductTypes]="dailyStockSoldOutProductTypes"
                  [scheduleOverrides]="outletScheduleOverrides.scheduleOverridesByOutletId[outlet.id] || []"
                  [isWaitUntilOutletSelect]="isWaitUntilOutletSelect"
                  [isOutletSelected]="isOutletSelected"
                  [orderId]="orderId"
                  [isAsapAvailable]="isAsapAvailable"
                  (onMapRequested)="onMapRequested.emit($event)"
                  (onOutletChange)="onOutletChange.emit($event)"
                  (onAsapSelected)="onAsapSelected.emit($event)"
                  (onNext)="onNext.emit()"
                ></pickup-outlet>
              </ng-template>
            </div>
          </div>
        </div>
      }
    }
  </div>

  <ng-container *ngIf="unavailableOutlets && unavailableOutlets.length">
    <div class="mt-3 mb-1 unavailable-outlet-warning"
         [translate]="'orderProcess.delivery.chooseOutlet.someProductsAreNotAvailable'">
      Some of products are not available for outlets
    </div>

    <ng-container *ngFor="let outlet of outlets">
      <div class="unavailable-outlet" *ngIf="outlet.unavailableProductTypes"
           ngbTooltip="{{'orderProcess.delivery.chooseOutlet.optionsIsNotAvailableForProducts' | translate: {'products': outlet.unavailableProductTypes} }}">
        <div class="title d-none d-md-flex">
          <div class="w-60 outlet-name">{{ outlet.name }}</div>
          <div class="w-40">{{ outlet.cityName }}</div>
        </div>

        <div class="d-md-none">
          <div class="w-100 fw-bold outlet-name">{{ outlet.name }}</div>
          <div class="font-xs fw-normal">{{ outlet.address }}, {{ outlet.cityName }}</div>
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>
